export default __webpack_public_path__ + "static/button-alignment-modal-dark-19ca17246a83a645f7cf050addf7f324.png";